(function($) {
	
	$(document).ready(function() {
		
		function form_is_valid( form ) {
			
//			console.log('is_valid?');
			form.find('.error_message').remove();
			form.find('.validate').trigger('validate');
			var errors = form.find('label.is-invalid');
			
			if( errors.length > 0 ) {
				
				return false;
				
			} else {
				
				form.find('label').removeClass('.is-valid .is-invalid');
				form.find('.error_message').remove();
				return true;
			}
		}
		
		function submitAuthForm(e) {
			
			event.preventDefault();
			event.stopPropagation();

			var form = $(this);
			var submit_btn = form.find('input[type="submit"]')
			var submit_text = submit_btn.val();			
			
			if( form_is_valid( form ) ) {

				submit_btn.val('Sending...');
				$.ajax({
					url: wds.ajaxurl,
					type: "POST",
					data: $(this).serialize(),
					success: function(response){
						
						submit_btn.val(submit_text);
						response = JSON.parse(response);
						
						if( response.success && response.message.length < 1 ) {
							document.location.href="/checkout";
							
						} else {
							var to_checkout = '';

							if( response.success && response.message != '' ) {
								to_checkout = 'to_checkout';
							}
							var message_el = $('<div class="error_message alert alert-danger ajax">' + response.message + '<div class="close-button '+ to_checkout +'"></div></div>');
							form.append(message_el);
						}
					}
				}); 
			}
			return false;
		}
		
		$('#LoginForm').on('submit', submitAuthForm);
		$('#SignupForm').on('submit', submitAuthForm);

		$(document).on("click", ".error_message .close-button", function(){
			$(".error_message").remove();

			if ( $(this).hasClass('to_checkout') ){
				document.location.href="/checkout";
			}
		});
	});
	
})(jQuery);